import React, { JSX } from "react";
import { useSelector } from "react-redux";
import { Autocomplete, Box, TextField } from "@mui/material";

import { RootState } from "../../store";
import { ServiceInterface } from "../../interfaces/ServiceInterface";

export const filterActiveService = (services: ServiceInterface[]): ServiceInterface[] =>
  services.filter((service) => service.active);

interface Props {
  onServiceSelect: (v: number | null) => void;
  defaultValue: number | null;
}

const DefaultServiceSelector = ({ onServiceSelect, defaultValue }: Props): JSX.Element => {
  const services = useSelector((state: RootState) => state.services.collection) || [];
  const filteredServices = filterActiveService(services);

  return (
    <Box display="flex" alignItems="center" width="100%">
      <Autocomplete
        fullWidth
        options={filteredServices}
        getOptionLabel={(option) => option.name || ""}
        renderOption={(params, option) => (
          // eslint-disable-next-line react/jsx-props-no-spreading
          <li {...params} key={option.id}>
            {option.name || ""}
          </li>
        )}
        defaultValue={filteredServices.find((service) => service.id === defaultValue)}
        limitTags={2}
        onChange={(_, v) => {
          onServiceSelect(v?.id || null);
        }}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            label="Default service for booking"
            slotProps={{
              inputLabel: { shrink: true }
            }}
            placeholder="Select default services"
            variant="outlined"
            margin="dense"
          />
        )}
      />
    </Box>
  );
};

export default DefaultServiceSelector;
